package hk.com.vr360_demo2.webapp.component.previewer

import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaSceneConfig
import hk.com.vr360_demo2.webapp.core.ui_state.NetworkState
import hk.com.vr360_demo2.webapp.core.ui_state.ProgressBarState

data class PreviewerState(
    val url: String = "",
    val autorotateEnabled: Boolean = false,
    val networkState: NetworkState = NetworkState.Good,
) {
    val scene: PanoramaSceneConfig?
        get() = url
            .trim()
            .takeIf { it.isNotEmpty() }
            ?.let {
                PanoramaSceneConfig(
                    id = "preview-scene",
                    url = it.trimEnd('/'),
                    name = "Preview",
                    linkHotspots = emptyList(),
                )
            }

    val progressBarState: ProgressBarState
        get() = ProgressBarState.Idle
}

sealed interface PreviewerIntent
